<style lang="scss" scoped>
  .AppFooter {
    /*    margin: 0;*/
    height: 60px;
    background-color: #ebebeb;
    padding: 22px 62px 21px 62px;
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
    float: left;

    @media only screen and (max-width: 768px) {
      height: 100px;
      padding: 0;
      text-align: center;
    }

    &__publish {
      width: 389px;
      height: 60px;
      padding-top: 5px;
      position: absolute;
      left: 0;
      bottom: 0;

      font-size: 20px;
      font-weight: 600;
      letter-spacing: 0.6px;
      text-align: center;
      cursor: pointer;
      @media only screen and (max-width: 1000px) {
        width: 270px;
      }
      @media only screen and (max-width: 768px) {
        margin-bottom: 80px;
        width: 100%;
      }
    }
    &__publish:active {
      box-shadow: 0 5px #666;
      transform: translateY(2px);
    }
    &__publish:focus {
      outline: none;
    }
    &__enabled {
      background-image: linear-gradient(81deg, #ff5000, #ed8a16);
      color: #ffffff;
    }
    &__enabled:hover {
      background: linear-gradient(45deg, #FF5000 0%, #EF8414 52.86%, #FFB41E 100%);
    }

    &__disabled {
      background-color: #D8D8D8;
      color: black;
      cursor: not-allowed;
    }
    &__text1 {
      height: 17px;
      font-size: 12px;
      font-weight: 600;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: center;
      color: #202020;
      margin-left: 162px;

      @media only screen and (max-width: 1240px){
        margin-left: 25%;
      }
      @media only screen and (max-width: 1000px) {
        margin: 0;
        padding: 0;
        position: relative;
      }
    }

    &__text2 {
      height: 20px;
      font-size: 15px;
      font-weight: 600;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: normal;
      color: #202020;
      float: right;

      @media only screen and (max-width: 768px) {
        float: none;
      }
    }

    &__logo {
      height: 18px;
      margin-left: 15px;
      position: relative;
      margin-bottom: -2px;
      float: right;

      @media only screen and (max-width: 768px) {
        float: none;
      }
    }
  }
  [tooltip]{
    display:inline-block;
  }
  [tooltip]::before {
    content: "";
    position: absolute;
    top:-6px;
    left:50%;
    transform: translateX(-50%);
    border-width: 4px 6px 0 6px;
    border-style: solid;
    border-color: rgba(0,0,0,0.7) transparent transparent     transparent;
    z-index: 99;
    opacity:0;
  }

  [tooltip-position='left']::before{
    left:0%;
    top:50%;
    margin-left:-12px;
    transform:translatey(-50%) rotate(-90deg)
  }
  [tooltip-position='top']::before{
    left:50%;
  }
  [tooltip-position='buttom']::before{
    top:100%;
    margin-top:8px;
    transform: translateX(-50%) translatey(-100%) rotate(-180deg)
  }
  [tooltip-position='right']::before{
    left:100%;
    top:50%;
    margin-left:1px;
    transform:translatey(-50%) rotate(90deg)
  }

  [tooltip]::after {
    content: attr(tooltip);
    position: absolute;
    left:50%;
    top:-6px;
    transform: translateX(-50%)   translateY(-100%);
    background: rgba(0,0,0,0.7);
    text-align: center;
    color: #fff;
    padding:4px 2px;
    font-size: 12px;
    min-width: 80px;
    border-radius: 5px;
    pointer-events: none;
    padding: 4px 4px;
    z-index:99;
    opacity:0;
    transition: opacity 1s;
  }

  [tooltip-position='left']::after{
    left:0%;
    top:50%;
    margin-left:-8px;
    transform: translateX(-100%)   translateY(-50%);
  }
  [tooltip-position='top']::after{
    left:50%;
  }
  [tooltip-position='bottom']::after{
    top:100%;
    margin-top:8px;
    transform: translateX(-50%) translateY(0%);
  }
  [tooltip-position='right']::after{
    left:100%;
    top:50%;
    margin-left:8px;
    transform: translateX(0%)   translateY(-50%);
  }

  [tooltip]:hover::after,[tooltip]:hover::before {
    opacity:1
  }
</style>

<template lang="pug">
  footer.AppFooter: .columns
    .column
      button.AppFooter__publish(@click="onPublish" :class="publishDisabled" :disabled="!isMarkerSet || !isMarkerDimensionsSet" v-show="!hidePublish" v-if="!isLoading" :tooltip="toolTipText") {{!isPublished ? 'Publish' : 'Update'}}
      button.button.is-loading.AppFooter__publish(v-if="isLoading")
    .column
      span.AppFooter__text1 &copy; 2018, MARS. All Rights Reserved.
    .column
      span.AppFooter__text2 Powered by
        img.AppFooter__logo(src="@/assets/img/mobi-logo.png" alt="Mobi Lab Logo")
</template>

<script>
  import { mapMutations, mapGetters, mapActions } from 'vuex';

  export default {
    name: 'AppFooter',

    props: {
      hidePublish: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        isLoading: false,
        isPublished: false,
        isMarkerSet: null,
        isObjectSet: null,
        isMarkerDimensionsSet: null,
        toolTipText: 'Marker and Object file must be added',
      };
    },
    computed: {
      ...mapGetters('Firebase', ['getARElemisPublishedSuccessfully', 'getARElemisPublishError', 'getisMarkerSet', 'getisObjectPartiallyComplete', 'getisMarkerDimensionsSet', 'getIsMarkerOnly']),
      whenARElemisPublishedSuccessfully() {
        return this.getARElemisPublishedSuccessfully;
      },
      whenARElemisPublishError() {
        return this.getARElemisPublishError;
      },
      getisMarkerSetFromState() {
        return this.getisMarkerSet;
      },
      getisObjectPartiallyCompleteFromState() {
        return this.getisObjectPartiallyComplete;
      },
      getisMarkerDimensionsSetFromState() {
        return this.getisMarkerDimensionsSet;
      },
      publishDisabled() {
        /* eslint-disable */
        return {
          AppFooter__disabled: !this.isMarkerSet || !this.isMarkerDimensionsSet,
          AppFooter__enabled: this.isMarkerSet && this.isMarkerDimensionsSet,
        };
        /* eslint-enable */
      },
      isMarkerOnly() {
        return this.getIsMarkerOnly;
      },
    },
    watch: {
      whenARElemisPublishedSuccessfully(newVal) {
        console.log('publish success');
        // if item is published.. stop loading.
        if (newVal) {
          this.isLoading = false;
          this.isPublished = true;
          this.toolTipText = 'Click to Update';
          // reset the values of verification.
          this.resetVerifyARElem();
        }
      },
      whenARElemisPublishError(newVal) {
        this.isLoading = !newVal;
      },
      getisMarkerSetFromState(newVal) {
        this.isMarkerSet = newVal;

        /* eslint-disable */
        if (this.isMarkerOnly) {
          if (this.isMarkerSet && this.isMarkerDimensionsSet) {
            this.toolTipText = 'Click to Publish';
          } else {
            this.toolTipText = 'Marker, and Marker Size must be added';
          }
        } else {
          if (this.isMarkerSet && this.isObjectSet && this.isMarkerDimensionsSet) {
            this.toolTipText = 'Click to Publish';
          } else {
            this.toolTipText = 'Marker,Object file and Marker Size must be added';
          }
        }
        /* eslint-enable */
      },
      getisObjectPartiallyCompleteFromState(newVal) {
        this.isObjectSet = newVal;

        if (this.isMarkerSet && this.isObjectSet && this.isMarkerDimensionsSet) {
          this.toolTipText = 'Click to Publish';
        } else {
          this.toolTipText = 'Marker,Object file and Marker Size must be added';
        }
      },
      getisMarkerDimensionsSetFromState(newVal) {
        this.isMarkerDimensionsSet = newVal;

        if (this.isMarkerSet && this.isObjectSet && this.isMarkerDimensionsSet) {
          this.toolTipText = 'Click to Publish';
        } else {
          this.toolTipText = 'Marker,Object file and Marker Size must be added';
        }
      },
    },
    methods: {
      ...mapMutations('Firebase', ['setPublishClicked', 'resetAREleminEditVerif', 'refreshAREleminEdit']),
      ...mapGetters('Firebase', ['getElementById', 'isNameChanged']),
      ...mapActions('Firebase', ['fetchARElementList']),
      onPublish() {
        // This will make all the watchers get that they
        // need to verify if they are ready to publish the AR Element yet.
        if (this.isMarkerOnly) {
          if (this.isMarkerSet && this.isMarkerDimensionsSet) {
            this.isLoading = true;
            this.setPublishClicked();
          }
        } else if (this.isMarkerSet && this.isObjectSet && this.isMarkerDimensionsSet) {
          if (this.isNameChanged()) {
            this.refreshAREleminEdit();
          }
          this.isLoading = true;
          this.setPublishClicked();
        }
      },
      resetVerifyARElem() {
        this.resetAREleminEditVerif();
        this.fetchARElementList();
        /* eslint-disable */
        setTimeout(function () {
          this.refreshAREleminEdit();
        }.bind(this), 2000);
        /* eslint-enable */
        // Vue.nextTick(() =>{
        //   this.basketAddSuccess = false;
        // });
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/AppFooter.vue